jQuery(function ($) {
  var duration = 200;
  var easing = "easeOutCubic";

  if (!$.easing.easeOutCubic) {
    $.easing.easeOutCubic = function (x) {
      return 1 - Math.pow(1 - x, 3);
    };
  }

  function setProductFaqIconOpen($item, isOpen) {
    $item.find("svg.accordion-icon").toggleClass("accordion-icon--open", isOpen);
  }

  function isProductFaqItemOpen($item) {
    return $item.children(".product-faq__item-content").hasClass("is-open");
  }

  function setProductFaqItemOpen($item, isOpen) {
    var $content = $item.children(".product-faq__item-content");
    var $header = $item.children(".product-faq__item-header");
    if (!$content.length) return;

    if (isProductFaqItemOpen($item) === isOpen) {
      setProductFaqIconOpen($item, isOpen);
      $header.attr("aria-expanded", isOpen ? "true" : "false");
      return;
    }

    $content.toggleClass("is-open", isOpen);
    setProductFaqIconOpen($item, isOpen);
    $header.attr("aria-expanded", isOpen ? "true" : "false");

    $content.stop(true, false);
    if (isOpen) {
      $content.slideDown(duration, easing);
    } else {
      $content.slideUp(duration, easing);
    }
  }

  $(document).on("click", ".product-faq__item-header", function () {
    var $header = $(this);
    var $accordion = $header.closest(".product-faq__accordion");
    if (!$accordion.length) return;

    var $item = $header.closest("li");
    if (!$item.length || $item.parent()[0] !== $accordion[0]) return;

    var willOpen = !isProductFaqItemOpen($item);

    if (willOpen) {
      $accordion.children("li").each(function () {
        var $otherItem = $(this);
        if ($otherItem[0] !== $item[0]) {
          setProductFaqItemOpen($otherItem, false);
        }
      });
    }

    setProductFaqItemOpen($item, willOpen);
  });
});
